import { css } from '@emotion/react';

import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';

export const container = css`
  width: 100%;
  ${flex('column', 'start', 'start')};
  ${MQ.MediaLg} {
    ${flex('row', 'space-between', 'start')};
    margin-bottom: 30px;
  }
`;
